module.exports = __webpack_public_path__ + "static/media/atef1.21961d31.webp";